import { Component, ErrorInfo, ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';
import { Translation } from 'react-i18next';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Мы игнорируем "Script error", так как это внешняя проблема TradingView
    console.warn("TradingView Widget Error caught:", error);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Translation>
          {/* 👇 ИСПРАВЛЕНИЕ: Добавляем тип ': any' для t */}
          {(t: any) => (
            <div className="w-full h-full flex flex-col items-center justify-center bg-[#1e293b] text-slate-500 rounded-2xl border border-slate-800">
              <AlertTriangle size={32} className="mb-2 text-orange-500" />
              <span className="text-xs font-bold uppercase">
                {t('platform.errors.chartReload')}
              </span>
              <button
                onClick={() => this.setState({ hasError: false })}
                className="mt-4 px-3 py-1 bg-blue-600 text-white rounded text-xs hover:bg-blue-500 transition-colors"
              >
                {t('platform.dashboard.refresh')}
              </button>
            </div>
          )}
        </Translation>
      );
    }

    return this.props.children;
  }
}